/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { ICreatePayPalOrderResponse } from './model';

export function isCreatePayPalOrderResponse(obj: any, _argumentName?: string): obj is ICreatePayPalOrderResponse {
  return (
    ((obj !== null && typeof obj === 'object') || typeof obj === 'function') &&
    ((obj.paypalCreateOrder !== null && typeof obj.paypalCreateOrder === 'object') ||
      typeof obj.paypalCreateOrder === 'function') &&
    ((obj.paypalCreateOrder.data !== null && typeof obj.paypalCreateOrder.data === 'object') ||
      typeof obj.paypalCreateOrder.data === 'function') &&
    typeof obj.paypalCreateOrder.data.payPalOrderId === 'string' &&
    Array.isArray(obj.paypalCreateOrder.messages) &&
    obj.paypalCreateOrder.messages.every((e: any) => typeof e === 'string')
  );
}
